// version is replaced by the version number during the build process
export const version = "Tue, 27/05/2025, 18:25";
